import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'
import { getPricingPageUrl } from 'helpers/account'
import { isFeatureEnabled } from 'helpers/features'
import { Features } from 'constants/feature_names'
import { SETTINGS_URLS } from 'constants/routes'
import { displayUpgradeModal } from 'helpers/account/users'

const TooltipContent = styled.div`
  line-height: 20px;

  b {
    font-weight: 600;
  }
`
const Link = styled.a`
  text-decoration: underline;
  color: ${props => props.theme.colors.primary};
`

const UpsellTooltip = ({ type }) => {
  const { t } = useTranslation('review_automation')
  const {
    checkout_locale,
    currency,
    selected_language,
    membershipInfo: { from_checkout },
    flagData
  } = useSelector(state => state.globalData?.user)

  const destinationURL = () => {
    if (
      displayUpgradeModal(
        isFeatureEnabled(Features.STRIPE_CUSTOMER_PORTAL, flagData),
        from_checkout
      )
    ) {
      return `/#${SETTINGS_URLS.subscriptions}`
    }
    return getPricingPageUrl(checkout_locale, currency, selected_language)
  }

  const getTooltipContent = () => {
    if (type === 'order_delay_skip') {
      return t(
        'review_automation:FeatureLimits.tooltips.order_delay_skip',
        'Your plan does not include the option to change review requests. Upgrade to a new plan where you can customize the request schedule to your needs.'
      )
    }

    if (type === 'order_delay' || type === 'product_delay') {
      return t(
        'review_automation:FeatureLimits.tooltips.order_delay',
        'Customizing review requests is a new feature that is only available when upgrading to the Professional plan.'
      )
    }

    if (type === 'product_delay_skip') {
      return (
        <Trans i18nKey="review_automation:FeatureLimits.tooltips.product_delay_skip">
          Your plan does not include the option to change review requests.
          <br />
          <br />
          Upgrade to the Professional plan and you can customize the request
          schedule for three orders from below.
        </Trans>
      )
    }

    return null
  }

  const getTooltipLinkText = () => {
    const isProductPage =
      type === 'product_delay_skip' || type === 'product_delay'

    return isProductPage
      ? t('review_automation:FeatureLimits.tooltips.link', 'View new plan')
      : t(
          'review_automation:FeatureLimits.tooltips.link2',
          'Learn more about plans'
        )
  }

  return (
    <TooltipContent>
      <b>
        {t(
          'review_automation:FeatureLimits.tooltips.title',
          'New premium feature'
        )}
      </b>
      <br />
      <br />
      {getTooltipContent()}
      <br />
      <br />
      <Link href={destinationURL()} target="_blank" rel="noopener noreferrer">
        {getTooltipLinkText()}
      </Link>
    </TooltipContent>
  )
}

UpsellTooltip.propTypes = {
  type: PropTypes.oneOf([
    'order_delay_skip',
    'order_delay',
    'product_delay_skip',
    'product_delay'
  ]).isRequired
}

export { UpsellTooltip }
